import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

type MarkNotificationsReadDialogProps = {
    open: boolean;
    notificationCount: number;
    onConfirm: () => void;
    onCancel: () => void;
};

export const MarkNotificationsReadDialog = ({
    open,
    notificationCount,
    onConfirm,
    onCancel,
}: MarkNotificationsReadDialogProps) => {
    const notificationText = notificationCount === 1 ? "notificação não lida" : "notificações não lidas";

    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Marcar notificações como lidas</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Tem {notificationCount} {notificationText} relacionadas com esta tarefa. Deseja marcá-las como lidas?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    Não
                </Button>
                <Button onClick={onConfirm} variant="contained" color="primary">
                    Sim
                </Button>
            </DialogActions>
        </Dialog>
    );
};

